import { render, staticRenderFns } from "./payFinish.vue?vue&type=template&id=50b1300d&scoped=true&"
import script from "./payFinish.vue?vue&type=script&lang=js&"
export * from "./payFinish.vue?vue&type=script&lang=js&"
import style0 from "./payFinish.vue?vue&type=style&index=0&id=50b1300d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b1300d",
  null
  
)

export default component.exports